module.exports = __webpack_public_path__ + "img/lhjl.78ddc893.png";